const defaultState = {
  journeys: null,//contains pagination data
  isLoadedJourneys: false,
  updatedJourneysActivityQueue: []
};

export const actionTypes = {
  JOURNEYS: 'JOURNEYS',
  IS_LOADED_JOURNEYS: 'IS_LOADED_JOURNEYS',
  PUSH_TO_UPDATED_JOURNEYS_ACTIVITY_QUEUE: 'PUSH_TO_UPDATED_JOURNEYS_ACTIVITY_QUEUE',
  PULL_FROM_UPDATED_JOURNEYS_ACTIVITY_QUEUE: 'PULL_FROM_UPDATED_JOURNEYS_ACTIVITY_QUEUE',
  CLEAR_UPDATED_JOURNEYS_ACTIVITY_QUEUE: 'CLEAR_UPDATED_JOURNEYS_ACTIVITY_QUEUE'
};

const journeysActions = function (state = defaultState, { type, payload }) {
  let updatedUpdatedJourneysActivityQueue;

  switch (type) {
    case actionTypes.JOURNEYS:
      return {
        ...state,
        journeys: payload
      };
    case actionTypes.IS_LOADED_JOURNEYS:
      return {
        ...state,
        isLoadedJourneys: payload
      };
    case actionTypes.PUSH_TO_UPDATED_JOURNEYS_ACTIVITY_QUEUE:
      updatedUpdatedJourneysActivityQueue = [...state.updatedJourneysActivityQueue, payload];
      return {
        ...state,
        updatedJourneysActivityQueue: updatedUpdatedJourneysActivityQueue
      };
    case actionTypes.PULL_FROM_UPDATED_JOURNEYS_ACTIVITY_QUEUE:
      updatedUpdatedJourneysActivityQueue = state.updatedJourneysActivityQueue;
      return {
        ...state,
        updatedJourneysActivityQueue: !!updatedUpdatedJourneysActivityQueue.length ? updatedUpdatedJourneysActivityQueue.slice(1) : updatedUpdatedJourneysActivityQueue
      };
    case actionTypes.CLEAR_UPDATED_JOURNEYS_ACTIVITY_QUEUE:
      return {
        ...state,
        updatedJourneysActivityQueue: []
      };
    default:
      return state;
  }
};

export default journeysActions;

export const setJourneys = payload => ({ type: actionTypes.JOURNEYS, payload });
export const setIsLoadedJourneys = payload => ({ type: actionTypes.IS_LOADED_JOURNEYS, payload });
export const pullFromUpdatedJourneysActivityQueue = () => ({ type: actionTypes.PULL_FROM_UPDATED_JOURNEYS_ACTIVITY_QUEUE });
export const pushToUpdatedJourneysActivityQueue = (payload) => ({ type: actionTypes.PUSH_TO_UPDATED_JOURNEYS_ACTIVITY_QUEUE, payload });
export const clearUpdatedJourneysActivityQueue = () => ({ type: actionTypes.CLEAR_UPDATED_JOURNEYS_ACTIVITY_QUEUE });
